import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class UbicacionesService {

  constructor(private http: HttpClient) { }

  getEstados() {
    return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/ubicacion/`);
  }

  getEstadosDental() {
    return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/ubicacion/estadodental`);
  }

  getEstadosNutricional() {
    return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/ubicacion/estadonutricional`);
  }

  getCiudades(id:any){
    return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/ubicacion/${id}`);
  }

  getCiudadesDental(id:any){
    return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/ubicacion/municipiodental?id=${id}`);
  }

  getCiudadesNutricional(id:any){
    return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/ubicacion/municipionutricional?id=${id}`);
  }

  getSucursalesDentales(id:any){
    return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/ubicacion/consultoriodental?id=${id}`);
  }

  getProcedimientosDentales(id:any, estado: any){
    return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/precios/preciodental?estado=${id}&municipio=${estado}`);
  }

  getSucursalesMedicas(id:any){
    return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/ubicacion/consultoriomedico?id=${id}`);
  }

  getProcedimientosMedicas(id:any, estado: any){
    return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/precios/preciomedico?estado=${id}&municipio=${estado}`);
  }

  getSucursalesNutricionales(id:any){
    return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/ubicacion/consultorioNutricional?id=${id}`);
  }

  getProcedimientosNutricional(id:any, estado: any){
    return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/precios/precionutricional?estado=${id}&municipio=${estado}`);
  }

  getPosicionMedico(latitudup:any, latituddow:any, longitudup:any, longituddow:any){
    return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/ubicacion/consultoriomedicoposition?latitudup=${latitudup}&latituddow=${latituddow}&longitudup=${longitudup}&longituddow=${longituddow}`);
  }
  getPosicionOdontologico(latitudup:any, latituddow:any, longitudup:any, longituddow:any){
    return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/ubicacion/consultoriodentalposition?latitudup=${latitudup}&latituddow=${latituddow}&longitudup=${longitudup}&longituddow=${longituddow}`);
  }
  getPosicionNutricional(latitudup:any, latituddow:any, longitudup:any, longituddow:any){
    return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/ubicacion/consultorioNutricionalposition?latitudup=${latitudup}&latituddow=${latituddow}&longitudup=${longitudup}&longituddow=${longituddow}`);
  }
  getEstadosPsicologicos(){
    return this.http.get('assets/data/estadospsicologicos.json');
  }

  getMunicipiosPsicologicos(){
    return this.http.get('assets/data/municipios-psicologicos.json');
  }

  getSucursalesPsicologicas(){
    return this.http.get('assets/data/sucursales-psicologicas.json');
  }
  //
  getEstadosEspecialidades(){
    return this.http.get('assets/data/estadosEspecialidades.json');
  }

  getMunicipiosEspecialidades(){
    return this.http.get('assets/data/municipiosEspecialidades.json');
  }
  getSucursalesEspecialidades(){
    return this.http.get('assets/data/sucursalesEspecialidades.json');
  }

  getUbicacionesSimiapse(){
     return this.http.get('assets/data/ubicacionesimiapse.json');

  }
}
